import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type {
  DuplicateTestConfigRequestParam,
  TestConfigOutput
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: TestConfigOutput) => ReactElement
  onSuccess?: (data: TestConfigOutput) => void
  id: string
  params: DuplicateTestConfigRequestParam
}

const DuplicateTestConfigRequest = ({
  params,
  children,
  onSuccess,
  id
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/test_configurations/${id}/clone`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default DuplicateTestConfigRequest
